exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-info-section {\n  padding: 60px; }\n\n.product-grid {\n  padding: 60px;\n  background: #f6f6f6; }\n\n.grid-container {\n  margin-top: 30px; }\n  .grid-container .product-image {\n    width: 100%;\n    height: 400px;\n    overflow: hidden; }\n\n.product-statistics {\n  padding: 60px; }\n\n.table {\n  width: 80%;\n  margin: auto;\n  margin-top: 30px; }\n  .table th, .table td {\n    text-align: center;\n    font-size: 14px; }\n\n.product-download {\n  padding: 60px;\n  background: #ffe6db; }\n  .product-download .download-btn {\n    border: none;\n    outline: none;\n    background: #c27948;\n    padding: 10px;\n    color: #fefefe;\n    height: auto;\n    font-size: 14px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/corpo-leve-www/www/src/app/product-detail/product-detail.component.scss
// module id = ../../../../../src/app/product-detail/product-detail.component.scss
// module chunks = main